import CardWithDoughnutChart from "./CardWithDoughnutChart";

export default CardWithDoughnutChart;
